import { useRoute } from 'vue-router'
import { ref, watch } from 'vue'
import { asyncTrack } from '@/track'
import { useHistoryStore } from '@/stores/history'

function convertPath(path: string): string {
  const map: Record<string, string> = {
    'home': '首页',
    'book': '书籍详情',
    'chapter': '章节阅读',
    'search': '搜索',
    'ranking': '排行榜',
    'member': '个人中心',
    'collection': '收藏夹',
    'history': '阅读历史',
    'pay': '支付页面',
    'recharge': '充值页面',
    'subscribe': '订阅页面',
    'setting': '设置',
    'tags': '标签',
    'contact-us': '联系我们',
    'recommend': '推荐页',
    'welfare': '福利',
  }
  return map[path] || path
}

export function pageViewTrack(key: string) {
  const historyStore = useHistoryStore()
  asyncTrack('biz_pageview', {
    host: window.location.host,
    url: window.location.href,
    tab: document.title,
    title: key,
    route_title: historyStore.prevPage?.route_title,
  })
}

export function setPageViewParams(name: string, path: string): string {
  return convertPath(path)
}

export function usePageTime() {
  const route = useRoute()
  const enterTime = ref(Date.now())

  watch(() => route.path, (newVal, oldVal) => {
    const duration = Date.now() - enterTime.value
    if (duration > 50) {
      asyncTrack('biz_pagetime', {
        duration: Math.floor(duration / 1000) || 0,
        route_title: convertPath(oldVal),
        title: convertPath(newVal),
      })
    }
    enterTime.value = Date.now()
  })
}
